import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  StressCheckListData,
  ActionType,
  IStressCheckListResponse,
} from "models/stressCheck/stressCheckList";
import { httpStatus } from "configs/httpStatus";
import { getStressCheckList } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./stressCheckListActions";

function* stressCheckListSaga({ payload }: { payload: StressCheckListData }) {
  try {
    const response: IStressCheckListResponse = yield call(
      getStressCheckList,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetStressCheckListWatcher() {
  yield takeLatest(ActionType.STRESS_CHECK_LIST as any, stressCheckListSaga);
}

export default [fork(onGetStressCheckListWatcher)];
